import { render } from "./Dashboard.vue?vue&type=template&id=4b34c06e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=4b34c06e&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=4b34c06e&scoped=true&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b34c06e"]])

export default __exports__